import MaintenancePage from "./maintenance.page.js";
export default {
  MaintenancePage
};
